import { render, staticRenderFns } from "./EmployeeManager.vue?vue&type=template&id=c9564bd4&scoped=true"
import script from "./EmployeeManager.vue?vue&type=script&lang=js"
export * from "./EmployeeManager.vue?vue&type=script&lang=js"
import style0 from "./EmployeeManager.vue?vue&type=style&index=0&id=c9564bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9564bd4",
  null
  
)

export default component.exports